import { UserDto } from '@bo-client/shared/models/userDto';
import { Type } from '@angular/core';
import { GrMastrNumbersComponent } from '@bo-client/activation-management/grid-registration/forms/gr-mastr-numbers/gr-mastr-numbers.component';
import { GrCustomApproveComponent } from '@bo-client/activation-management/grid-registration/forms/gr-custom-approve/gr-custom-approve.component';
import { GrPluginCustomApproveComponent } from '@bo-client/activation-management/grid-registration/forms/gr-plugin-custom-approve/gr-plugin-custom-approve.component';
import { GrConfirmFeedinConfigurationComponent } from '@bo-client/activation-management/grid-registration/forms/gr-confirm-feedin-configuration/gr-confirm-feedin-configuration.component';
import { GrChangeStateComponent } from '@bo-client/activation-management/grid-registration/gr-change-state/gr-change-state.component';
import { CrChangeStateComponent } from '@bo-client/activation-management/commissioning/cr-change-state/cr-change-state.component';
import { GrTransferToTechnicianComponent } from '@bo-client/activation-management/grid-registration/gr-transfer-to-technician/gr-transfer-to-technician.component';
import { GrPlaceInServiceRequestFormComponent } from '@bo-client/activation-management/grid-registration/forms/gr-place-in-service-request-form/gr-place-in-service-request-form.component';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { CreateErpOrderComponent } from '@bo-client/shared/components/create-erp-order/create-erp-order.component';
import { FcChangeStateComponent } from '@bo-client/activation-management/feeder-contract/fc-change-state/fc-change-state.component';
import { TrSrFormComponent } from '@bo-client/activation-management/grid-registration/forms/tr-sr-form/tr-sr-form.component';
import { MaloMeloFormComponent } from '@bo-client/activation-management/grid-registration/forms/malo-melo-form/malo-melo-form.component';
import { CrCompletitionFormComponent } from '@bo-client/activation-management/commissioning/forms/cr-completition-form/cr-completition-form.component';
import { CrSubmitNewDateFormComponent } from '@bo-client/activation-management/commissioning/forms/cr-submit-new-date-form/cr-submit-new-date-form.component';
import { CrReportDefectFormComponent } from '@bo-client/activation-management/commissioning/forms/cr-report-defect-form/cr-report-defect-form.component';
import { CcrChangeStatusComponent } from '@bo-client/nap/connection-change/actions/ccr-change-status-modal/ccr-change-status.component';
import { RequestModel } from '@bo-client/shared/models/request.model';
import { CrSendOfferFormComponent } from '@bo-client/activation-management/commissioning/forms/cr-send-offer-form/cr-send-offer-form.component';
import { NBPConfig } from '@bo-client/shared/config.model';

export class ActionWithMoreInfoModel<T extends RequestModel = RequestModel> {
  action = '';
  actionUrl = '';
  secondAction? = '';
  actionName = '';
  subject?: string = null;
  comment?: string = null;
  successMessage = '';
  failureMessage = '';
  recipients? = '';
  execute?: string;
  disabled?: (user: UserDto) => boolean;
  infoInButton? = '';
  customForm?: Type<CustomFormComponent<T, any>>;
  validateForm? = false;
  preActionHook?: (actionInfo: ActionWithMoreInfoModel, entity: any) => void;
  additionalData?: any = null;
  commentRequested?: string = null;
  customAction?: string = null;
  visibleCondition?: (entity: T, state: T['state'], user: UserDto, tenantConfig: NBPConfig) => boolean;

  tooltip?: string = null;
  detailedTooltip?: string = null;
  actionType?: ActionWithMoreInfoType = 'primary';
}

export const CustomFormTypes = {
  PlaceInServicesRequestedForm: GrPlaceInServiceRequestFormComponent,
  MaStRNumberForm: GrMastrNumbersComponent,
  GrCustomApprove: GrCustomApproveComponent,
  GrPluginCustomApprove: GrPluginCustomApproveComponent,
  GrConfirmFeedingConfiguration: GrConfirmFeedinConfigurationComponent,
  GrTransferToTechnician: GrTransferToTechnicianComponent,
  GrChangeStatus: GrChangeStateComponent,
  CrChangeStatus: CrChangeStateComponent,
  FcChangeStatus: FcChangeStateComponent,
  CcrChangeStatus: CcrChangeStatusComponent,
  CreateERPOrder: CreateErpOrderComponent,
  MaLoMeloForm: MaloMeloFormComponent,
  SrTrForm: TrSrFormComponent,
  CrCompletitionForm: CrCompletitionFormComponent,
  CrSubmitNewDateForm: CrSubmitNewDateFormComponent,
  CrReportDefectForm: CrReportDefectFormComponent,
  CrSendOfferForm: CrSendOfferFormComponent
};

export class DataForCustomFormModel<InputData> {
  actionInfo: ActionWithMoreInfoModel;
  model: InputData;
}

/**
 * TODO: Ausspezifizieren was wann passiert. Das ist momentan nicht gut genug dokumentiert / nicht intuitiv
 */
export const ExecutionActionsTypes = {
  save: 'save',
  checkIfErrors: 'checkIfErrors',
  executeAction: 'executeAction',
  confirmActionWithComment: 'confirmActionWithComment',
  saveAndActionPlusMail: 'saveAndActionPlusMail',
  generateDocument: 'generateDocument',
  createDocumentV2: 'createDocumentV2',
  confirmAction: 'confirmAction',
  createCommissioningFromGriReg: 'createCommissioningFromGriReg',
  customFormWithCustomActionModal: 'customFormWithCustomActionModal',
  customAction: 'customAction',
  createExternalGridRegistration: 'createExternalGridRegistration',
  remove: 'remove' // Löst eine Delete-Request für die übergebene Entity aus!
};

export const SecondActionTypes = {
  saveModel: 'saveModel',
  saveModelAndActionPlusMail: 'saveModelAndActionPlusMail'
};

export const CustomActionTypes = {
  checkIfCRHasNonApproveGR: 'checkIfCRHasNonApproveGR',
  checkIfGRPlaceInServiceAndMaStrRegisterDates: 'checkIfGRPlaceInServiceAndMaStrRegisterDates'
};

export type ActionWithMoreInfoType = 'primary' | 'secondary' | 'danger';
